import { Box, Grid } from "@mui/material"
import { EditProfile } from "../../../../../core/global/Icons"
import { useHistory } from "react-router-dom"
import { PrimaryToolTip } from "../../../../../core/global/ToolTip"
import { useContext, useEffect } from "react"
import { ToolContext } from "../../../../../core/context/ToolContext"
import { ListLoader } from "../../loader/ListLoader"
import { CutoffRead } from "../../../global/API"
import { useState } from "react"
import dayjs from "dayjs"

export const List = ({__SESSION}) => {
    const nav = useHistory()
    const { setup_state, global_component_state } = useContext(ToolContext)
    const { listLoader } = setup_state
    const { snackBarLoader } = global_component_state

    const [cutoff, setCutoff] = useState([])

    const redirectionHandler = (value) => {
        snackBarLoader.set({...snackBarLoader.data, snackbar:false, msg:''})
        nav.push(`/setup/cutoff/${window.btoa(JSON.stringify(value))}`)
    }

    const ReadCutoff = async() =>{
        let qsp ={
            company_id: __SESSION.data.uaccess[0].company_id,
            filter: "company"
        }
        listLoader.set((prev) => ({...prev.data, isloading:true}))
        let res = await CutoffRead(qsp)
        if (res) {
            setCutoff(res.length > 0 ? res[0] : res)
            listLoader.set((prev) => ({...prev.data, isloading:false}))
        }
    }

    useEffect(() => {
        ReadCutoff()
        //eslint-disable-next-line
    }, [])

    return (
        <Box sx={{height: "100%", display: "flex", flexDirection: "column", gap: 2}}>
            <Box width="100% "bgcolor="#FFFFFF" borderRadius="12px" display="flex" flexDirection="column" p={3}>
                <Box minHeight="60px" display="flex" flexDirection="column" gap={3}>
                    <Grid container direction="row" sx={{px:2}}>
                        <Grid item xs={6}></Grid>
                        <Grid item xs={4} textAlign="center">Time</Grid>
                        <Grid item xs={2} textAlign="center">Action</Grid>
                    </Grid>
                </Box>
                {listLoader.data.isloading && <ListLoader/>}
                {!listLoader.data.isloading && 
                    <Box height="100%" width="100%" className="overflowY" display="flex" flexDirection="column" gap="12px">
                        <Grid container direction="row" sx={{p:2, border:'1px solid #EBEBEB', borderRadius:'10px'}}>
                            <Grid item xs={6}>Company Business Cutoff Time</Grid>
                            <Grid item xs={4} textAlign="center">
                                {cutoff?.cutoff_time 
                                    ? dayjs(cutoff.cutoff_time, "HH:mm:ss").format("hh:mm A") 
                                    : "12:00 AM"
                                }
                            </Grid>
                            <Grid item xs={2} textAlign="center">
                                <PrimaryToolTip onClick={()=>redirectionHandler(cutoff)} title="Update" arrow sx={{margin: '0 14px 0 14px'}} placement="top">
                                    <Box fontWeight={500} className="c-pointer">
                                        <EditProfile fill={'none'} stroke={'#292d32'}/>
                                    </Box>
                                </PrimaryToolTip>
                            </Grid>
                        </Grid>
                    </Box>
                }
            </Box>
        </Box>
    )
}